<ngx-extended-pdf-viewer
  [src]="this.data.pdfPath"
  useBrowserLocale="true"
></ngx-extended-pdf-viewer>
